import * as Sentry from "@sentry/remix";
import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";
import { locales, setLocale } from "./generated/i18n/runtime";

Sentry.init({
  dsn: "https://b8e138f7649abb5cee30a06f4f49cca9@o4509546092691456.ingest.us.sentry.io/4509546092953600",

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/remix/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),

    // Replay is only available in the client
    Sentry.replayIntegration(),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // We recommend adjusting this value in production
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    /^https:\/\/pikupaku\.fly\.dev/,
    /^https:\/\/pikupaku-staging\.mnqst\.com/,
    /^https:\/\/pikupaku-production\.fly\.dev/,
    /^https:\/\/pikupaku\.mnqst\.com/,
  ],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

startTransition(() => {
  const languageTagInSearchParams =
    new URLSearchParams(document.URL).get("locale") || "en";
  const languageTag = locales.includes(languageTagInSearchParams as any)
    ? languageTagInSearchParams
    : "en";

  // Set the language tag for ParaglideJS
  setLocale(languageTag as any, { reload: false });

  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  );
});
